import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × PAPIER TIGRE: Paper systems as modular logic
// Color blocks, paper geometry, archival grids
export function VasarelyPapiertigreMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="tigre-yellow" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFD700" />
          <stop offset="100%" stopColor="#FFC107" />
        </linearGradient>
        <linearGradient id="tigre-pink" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FF69B4" />
          <stop offset="100%" stopColor="#FF1493" />
        </linearGradient>
        <linearGradient id="tigre-blue" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00CED1" />
          <stop offset="100%" stopColor="#00BFFF" />
        </linearGradient>
        <linearGradient id="tigre-green" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#32CD32" />
          <stop offset="100%" stopColor="#00FA9A" />
        </linearGradient>
      </defs>

      {/* White background */}
      <rect x="0" y="0" width="794" height="1123" fill="#FFFFFF" />

      <g transform="translate(397 540)">
        {/* Color blocks (stationery colors) */}
        {[
          { x: -300, y: -400, w: 200, h: 250, fill: "url(#tigre-yellow)" },
          { x: -80, y: -400, w: 180, h: 200, fill: "url(#tigre-pink)" },
          { x: 120, y: -400, w: 180, h: 300, fill: "url(#tigre-blue)" },
          { x: -300, y: -120, w: 160, h: 220, fill: "url(#tigre-green)" },
          { x: -120, y: -100, w: 240, h: 280, fill: "url(#tigre-yellow)" },
          { x: 140, y: -70, w: 160, h: 250, fill: "url(#tigre-pink)" },
          { x: -300, y: 120, w: 220, h: 280, fill: "url(#tigre-blue)" },
          { x: -60, y: 200, w: 180, h: 200, fill: "url(#tigre-green)" },
          { x: 140, y: 200, w: 160, h: 200, fill: "url(#tigre-yellow)" },
        ].map((block, i) => (
          <rect
            key={i}
            x={block.x}
            y={block.y}
            width={block.w}
            height={block.h}
            fill={block.fill}
            opacity="0.2"
            stroke="#FFFFFF"
            strokeWidth="3"
          />
        ))}

        {/* Archival grids */}
        {Array.from({ length: 14 }).map((_, i) =>
          Array.from({ length: 20 }).map((_, j) => {
            const x = (i - 6.5) * 54;
            const y = (j - 9.5) * 54;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 25}
                y={y - 25}
                width="50"
                height="50"
                fill="none"
                stroke="#CCCCCC"
                strokeWidth="1"
                opacity="0.3"
              />
            );
          })
        )}

        {/* Paper geometry modules */}
        {[
          { x: -100, y: -150, angle: 15 },
          { x: 80, y: -100, angle: -10 },
          { x: -80, y: 50, angle: 5 },
          { x: 100, y: 100, angle: -15 },
        ].map((module, i) => {
          const colors = ["#FFD700", "#FF69B4", "#00CED1", "#32CD32"];
          return (
            <g key={i} transform={`translate(${module.x} ${module.y}) rotate(${module.angle})`}>
              <rect
                x="-40"
                y="-50"
                width="80"
                height="100"
                fill={colors[i]}
                opacity="0.3"
                stroke={colors[i]}
                strokeWidth="2"
              />
              <rect
                x="-35"
                y="-45"
                width="70"
                height="90"
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="1"
              />
            </g>
          );
        })}

        {/* Modular logic circles */}
        {Array.from({ length: 10 }).map((_, i) => {
          const r = 60 + i * 28;
          const colors = ["#FFD700", "#FF69B4", "#00CED1", "#32CD32"];
          
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={colors[i % 4]}
              strokeWidth="2"
              opacity={0.3 - i * 0.025}
            />
          );
        })}

        {/* Central organization system */}
        <rect x="-80" y="-80" width="160" height="160" fill="url(#tigre-yellow)" opacity="0.2" />
        <rect x="-70" y="-70" width="140" height="140" fill="url(#tigre-pink)" opacity="0.2" />
        <rect x="-60" y="-60" width="120" height="120" fill="url(#tigre-blue)" opacity="0.2" />
        <rect x="-50" y="-50" width="100" height="100" fill="url(#tigre-green)" opacity="0.2" />
        
        {/* Tiger stripes pattern */}
        {Array.from({ length: 8 }).map((_, i) => {
          const angle = i * 45;
          const rad = (angle * Math.PI) / 180;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(rad) * 50}
              y2={Math.sin(rad) * 50}
              stroke="#333333"
              strokeWidth="3"
              opacity="0.3"
            />
          );
        })}
      </g>

      {/* Organization through pattern */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="sans-serif" fontSize="10" fill="#333333" fontWeight="600" letterSpacing="2">
        PATTERN PLAY LOGIC
      </text>
    </g>
  );
}
